import React from 'react';
import { CandidateResumeViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: CandidateResumeViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
